import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { images } from 'config';
import styled from 'styled-components';
import { strings } from 'config';

const getMunUrl = municipality => {
  const munUrlName = municipality.replace(/\s+/g, '');
  const isProd =
    process.env.NODE_ENV === 'production' && !window.location.hostname.includes('staging');

  if (munUrlName === 'AllMunicipalities') {
    return isProd ? 'https://library.susasan.org' : 'http://library.staging.susasan.org';
  } else {
    return isProd
      ? `https://${munUrlName}.susasan.org`
      : `http://${munUrlName}.staging.susasan.org`;
  }
};

const Logo = ({ municipality }) => (
  <Content className="logo" lang={strings.getLanguage()}>
    <div>
      <NavLink to="/">
        <span className="app-name">{strings.logoText}</span>
      </NavLink>
    </div>
  </Content>
);

export default connect(state => ({
  municipality: state.filters.municipality.nameEn
}))(Logo);

const Content = styled.div`
  display: flex;
  align-items: flex-end;

  .susasan-logo {
    margin: 0 9px 8px 0;
    display: inline-block;
    vertical-align: bottom;

    @media screen and (min-width: 400px) {
      margin: 0 7px 0 0;
    }
  }
  .app-name {
    color: #f0f8ff;
    font-size: ${props => (props.lang === 'en' ? '15px' : '18px')};
    text-transform: uppercase;
    font-weight: 700;
    display: block;

    @media screen and (min-width: 400px) {
      display: inline;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/navbar/logo.js